// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.24.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// LiveWatch makes use of fixed elements on almost every page. CSS alone is
// rarely enough to tame fixed elements and get the behavior you want,
// especially with positioning. These Javascript helpers fill those gaps.
//
// TODO: investigate merging Shadow into this.
// -----------------------------------------------------------------------------

import Utils from './utils'
import ScrollFade from './scroll-fade'

const FixedHelper = (($) => {
  const Selectors = {
    FLUID: '.js-fixed-fluid',
    TOP: '.js-fixed-top'
  }

  /* --------------------------------------------------------------------------
    Private
  -------------------------------------------------------------------------- */

  function setFixedFluidWidths () {
    for (let fixedEl of $(Selectors.FLUID)) {
      let width = $(fixedEl).parent().width()
      Utils.setElementWidth(fixedEl, width)
    }
  }

  function refreshTopHeight () {
    FixedHelper.topHeight = 0

    for (let fixedTopEl of $(Selectors.TOP)) {
      FixedHelper.topHeight += $(fixedTopEl).outerHeight(true)
    }
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  let FixedHelper = {
    topHeight: 0,

    // Tracks the sum total height of fixed elements that stack at the top
    // of the page. To use, add the `js-fixed-top` class to all such elements.
    initTopHeightTracker () {
      const revealEvents = `${ScrollFade.Event.SHOWN} ${ScrollFade.Event.HIDDEN}`

      refreshTopHeight()

      // Play nice with ScrollFade. Update topHeight when fixed-top elements are
      // faded in or faded out.
      $(Selectors.TOP).on(revealEvents, () => {
        refreshTopHeight()
      })
    },

    // Use the FluidWidths helper to make a fixed element act like a
    // block element and fill the full width of its parent.
    // - Add the `js-fixed-fluid` class to fixed element you wanna make fluid.
    initFluidWidths () {
      // Set on initial load
      setFixedFluidWidths()
      // Set again if user resizes window
      $(window).resize(setFixedFluidWidths)
    }
  }

  return FixedHelper
})(jQuery)

export default FixedHelper
